import { nodeListToArray } from '../helpers/nodeListToArray';
import * as _ from 'lodash';

function wrapAll(node: HTMLElement, container: HTMLElement) {
    // Cache the current parent and previous sibling of the node.
    var parent = node.parentNode;
    var previousSibling = node.previousSibling;

    // Place node in wrapper.
    container.appendChild(node);

    // Place the wrapper just after the cached previousSibling,
    // or if that is null, just before the first child.
    var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
    parent.insertBefore(container, nextSibling);

    checkPadding(container);

    return container;
}

function checkPadding(image: HTMLElement) {
    removePadding(image);

    window.addEventListener('resize', function() {
        removePadding(image);
    });
}

function removePadding(imageContainer: HTMLElement) {
    let imageWidth = Math.ceil(imageContainer.querySelector('img').offsetWidth);

    if (window.innerWidth >= 960) {
        if (imageWidth > 625) {
            imageContainer.classList.add('adage-wysiwyg-img-container-full');
        } else {
            imageContainer.classList.remove('adage-wysiwyg-img-container-full');
        }
    } else if (window.innerWidth >= 600) {
        if (imageWidth > 375) {
            imageContainer.classList.add('adage-wysiwyg-img-container-full');
        }
    }
}

export default function() {
    let wysiwygBlocks = nodeListToArray(document.querySelectorAll('.adage-wysiwyg-block'));

    wysiwygBlocks.forEach(wysiwygBlock => {
        let richTextArray = nodeListToArray(wysiwygBlock.querySelectorAll('.rich-text'));

        richTextArray.forEach(richText => {
            let imageNodes = nodeListToArray(richText.querySelectorAll('img'));

            if (imageNodes.length > 0) {
                let tableNodesArray = nodeListToArray(imageNodes);

                _.forEach(tableNodesArray, tableNode => {
                    let containerSpan = document.createElement('span');

                    containerSpan.classList.add('adage-wysiwyg-img-container');

                    wrapAll(tableNode, containerSpan);
                });
            }
        });
    });
}
